/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Api_Keys_DescriptionInputs */

const en_directory_integrate_api_keys_description = /** @type {(inputs: Directory_Integrate_Api_Keys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the authenticated account area to manage your existing API access.`)
};

const zh_directory_integrate_api_keys_description = /** @type {(inputs: Directory_Integrate_Api_Keys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在登录后的账户区域管理现有 API 访问权限。`)
};

/**
* | output |
* | --- |
* | "Use the authenticated account area to manage your existing API access." |
*
* @param {Directory_Integrate_Api_Keys_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_api_keys_description = /** @type {((inputs?: Directory_Integrate_Api_Keys_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Api_Keys_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_api_keys_description(inputs)
	return zh_directory_integrate_api_keys_description(inputs)
});
export { directory_integrate_api_keys_description as "directory.integrate.api_keys.description" }